import { connect } from 'react-redux';
import ShopList from '../components/ShopList';

const mapStateToProps = ({search, config}) => ({
    shops: search.result,
    showHowTo: search.result.length === 0,
    isFetching: search.isFetching,
    sortCode1: config.sortCode1
});

const ShopListContainer = connect(mapStateToProps)(ShopList);

export default ShopListContainer;
